import { required } from '@vuelidate/validators';

export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1 - 10' },
  { value: '11-50', label: '11 - 50' },
  { value: '51-200', label: '51 - 200' },
  { value: '201-500', label: '201 - 500' },
  { value: '500+', label: '500+' },
];

export const INDUSTRY_OPTIONS = [
  { value: 'Aerospace & Defense', label: 'Aerospace & Defense' },
  { value: 'Agriculture & Food', label: 'Agriculture & Food' },
  {
    value: 'Automotive & Transportation',
    label: 'Automotive & Transportation',
  },
  { value: 'Chemicals & Materials', label: 'Chemicals & Materials' },
  {
    value: 'Construction & Built Environment',
    label: 'Construction & Built Environment',
  },
  {
    value: 'Consumer Packaged Goods (CPG)',
    label: 'Consumer Packaged Goods (CPG)',
  },
  { value: 'Education', label: 'Education' },
  { value: 'Entertainment', label: 'Entertainment' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Government & Nonprofit', label: 'Government & Nonprofit' },
  { value: 'Healthcare', label: 'Healthcare' },
  { value: 'Hospitality & Tourism', label: 'Hospitality & Tourism' },
  { value: 'Industrial & Energy', label: 'Industrial & Energy' },
  { value: 'Legal & Compliance', label: 'Legal & Compliance' },
  { value: 'Lifestyle & Leisure', label: 'Lifestyle & Leisure' },
  { value: 'Logistics & Supply Chain', label: 'Logistics & Supply Chain' },
  { value: 'Luxury & Fashion', label: 'Luxury & Fashion' },
  { value: 'News & Media', label: 'News & Media' },
  {
    value: 'Professional Services & Agencies',
    label: 'Professional Services & Agencies',
  },
  { value: 'Real Estate & PropTech', label: 'Real Estate & PropTech' },
  { value: 'Retail & E-commerce', label: 'Retail & E-commerce' },
  { value: 'Sports', label: 'Sports' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Telecommunications', label: 'Telecommunications' },
  { value: 'Other', label: 'Other' },
];

export const REFERRAL_SOURCE_OPTIONS = [
  { value: 'google', label: 'Google' },
  { value: 'reddit', label: 'Reddit' },
  { value: 'twitter', label: 'Twitter/X' },
  { value: 'linkedin', label: 'LinkedIn' },
  { value: 'friend', label: 'Friend/Colleague' },
  { value: 'blog', label: 'Blog/Article' },
  { value: 'github', label: 'GitHub' },
  { value: 'other', label: 'Other' },
];

export const USER_ROLE_OPTIONS = [
  { value: 'founder', label: 'Founder/CEO' },
  { value: 'product_manager', label: 'Product Manager' },
  { value: 'engineering', label: 'Engineering' },
  { value: 'support_lead', label: 'Support Lead' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'sales', label: 'Sales' },
  { value: 'other', label: 'Other' },
];

// Idioma e fuso mudam textos e relatórios da conta desde o primeiro dia, então
// são os dois obrigatórios. Os dois já vêm preenchidos (idioma do navegador e
// fuso do aparelho): a regra só barra quem apagar o valor. Os outros campos
// seguem opcionais; a chave vazia existe porque o template lê o $error deles.
// Sem Object.freeze: o useVuelidate não enxerga as regras de um objeto
// congelado e o formulário passava sem idioma e sem fuso.
export const ONBOARDING_VALIDATION_RULES = {
  userRole: {},
  website: {},
  locale: { required },
  timezone: { required },
  companySize: {},
  industry: {},
  referralSource: {},
};
